<template>
  <div class="inner-content">
    <div class="addlocationClass">
      <tl-radio name="uploadMethod1" label="Bulk Upload" id="bulkUpload" value="bulkUpload" v-model="uploadMethod"
      />
      <tl-radio name="uploadMethod2" label="Manual" id="manualUpload" value="manualUpload" v-model="uploadMethod"
      />
    </div>
    <div class v-if="uploadMethod == 'bulkUpload'">
      <tl-select class="margintop-20" label="Document Category" labelText="docName" :options="documentTypes" :v-model="formData.docType"
        @change="(val)=>formData.docType = val.id" name="documentCategory" v-validate="'required'" :classname="errors.has('documentCategory')"
        :errormsg="errors.first('documentCategory')" />
      <div class="margintop-30">
          <div class="download-btn">
              <download-button></download-button>
            </div>
        <!-- <label class="input-label">Upload Document</label> -->
        <upload />
      </div>
    </div>
    <div v-else>
      <div class="">
        <selected-employee-card class="margintop-40" empName="" empId="" empMail="" :dates="false"
        />
      </div>
      <tl-select class="margintop-20" label="Document Category" labelText="docName" :options="documentTypes" :v-model="formData.docType"
        @change="(val)=>formData.docType = val.id" name="documentCategory" v-validate="'required'" :classname="errors.has('documentCategory')"
        :errormsg="errors.first('documentCategory')" />
      <div class="margintop-30">
          <div class="download-btn">
              <download-button></download-button>
            </div>
        <!-- <label class="input-label">Upload Document</label> -->
        <upload />
      </div>
      <div class="margintop-20">
        <btn text="Add" type="secondary" class @click="addFile"></btn>
      </div>
      <div class="margintop-20">
        <data-table 
          :columns="documentColumns" 
          :tableData="documentsData" 
          :withForm="false" 
          :actionicons="[{url:require('@/assets/delete.svg'), method: 'delete'}]"
          @delete="deleteItem" 
          :showinrow="false">
          <template v-slot:rowcontent="slotprops">
            <p v-if="slotprops.value.column.key !='documents'">{{slotprops.value.record[slotprops.value.column.key]}}</p>
            <p v-if="slotprops.value.column.key =='documents'">
              <img class="vertical-align-middle" :src="slotprops.value.record[slotprops.value.column.key].icon" />{{slotprops.value.record[slotprops.value.column.key].folderName}}</p>
          </template>
        </data-table>
      </div>
    </div>
    <footer>
      <bottom-action-container class="position-fixed">
        <btn-grp slot="end">
          <btn text="Cancel" type="secondary" class @click="cancel"></btn>
          <btn text="Submit" type="primary" class @click="submit"></btn>
        </btn-grp>
      </bottom-action-container>
    </footer>
  </div>
</template>
<script>

  import SelectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
  export default {
    components: {
      SelectedEmployeeCard
    },
    data() {
      return {
        formData: {},
        uploadMethod: "manualUpload",
        documentTypes: [
          {
            id: 1,
            docName: "Education"
          },
          {
            id: 2,
            docName: "Identification Proofs"
          },
          {
            id: 3,
            docName: "Work Experience"
          }
        ],
        documentColumns: [
          {
            label: 'Document Category',
            key: 'doctype'
          },
          {
            label: 'Uploaded Date',
            key: 'uploadDate'
          },
          {
            label: 'Modified Date',
            key: 'modifyData'
          },
          {
            label: 'Modified By',
            key: 'modifiedBy'
          },
          {
            label: 'Documents',
            key: 'documents'
          },
        ],
        documentsData: [
          {
            doctype: 'Education',
            uploadDate: '13 Jan 2019',
            modifyData: '13 Jul 2019',
            modifiedBy: 'Blake Moran',
            documents: {
              folderName: 'education',
              icon: require('@/assets/group-3.png'),
              files: [
                {
                  fileName: 'education.pdf'
                },
                {
                  fileName: 'education.pdf'
                },
                {
                  fileName: 'education.pdf'
                },
              ]
            }
          }
        ]
      };
    },
    methods: {
      cancel() {

      },
      deleteItem(record) {
        //console.log('record', record);
      },
      addFile() {

      },
      getType(valuetype) {
        //console.log('type', typeof valuetype);
      },
      // getFileName(){
      //   let fileName;
      //   for(let fileData of this.documentsData){
      //     fileName = fileData.documents.folderName;
      //   }
      // },
      changeHandler(val) {
        this.formData.docType = val.id
      },
      submit() {
        this.$validator.validateAll().then(result => {
          //console.log('formData', this.formData);
          if (result) {
            //console.log("perform signup", result);
            // this.performAction().then(() => {
            //   this.showSuccessMsg = true;
            // });
          }
        });
      }
    }
  };
</script>
<style lang="scss" scoped>
  .addlocationClass {
    display: flex;
  }

  .download-btn {
    margin-top: 2%;
  }

  .margin-top-30{
    margin-top: 30px;
  }

  .vertical-align-middle {
    vertical-align: middle;
    padding-right: 10px;
  }

  .download-btn {
    margin-top: 2%;
  }
</style>